import './PromoRedemptionSelector.pcss';
import React, { useCallback, useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import promotionsCRUDActions from '@mm/state/actions/PromotionsCRUDActions';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import PromotionModel from '@mm/state/model/PromotionModel';
import PrimarySelect from '../../../../../../../../common/components/PrimarySelect/PrimarySelect';

type OuterProps = {
  facebookPageId: number;
  promotions: PromotionModel[];
};

type InnerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

type Props = OuterProps & InnerProps;

const PromoRedemptionSelector = ({
  promotions,
  connectCode,
  company,
  facebookPageId,
}: Props) => {
  const [selectedPromotion, setSelectedPromotion] = useState<
    PromotionModel | undefined
  >(undefined);

  const connectPromoCode = useCallback(() => {
    if (selectedPromotion && company) {
      connectCode(selectedPromotion.id, company.id, facebookPageId);
    }
  }, [connectCode, selectedPromotion, facebookPageId]);

  return (
    <div className="promo-redemption-selector">
      <PrimarySelect
        displayNameKey="code"
        options={promotions}
        value={selectedPromotion}
        onChange={(promotion: PromotionModel) =>
          setSelectedPromotion(promotion.id ? promotion : undefined)
        }
        placeholder="Choose promo code"
        className="promo-redemption-selector__select"
        dropdownClassName="promo-redemption-selector__select-dropdown"
        showPlaceholderInDropdown={true}
      />

      {!!selectedPromotion && (
        <PrimaryButton
          color={ButtonColor.secondaryBlue}
          onClick={connectPromoCode}
          className="promo-redemption-selector__promotion-button"
        >
          Confirm code
        </PrimaryButton>
      )}
    </div>
  );
};

const mapStateToProps = (state: StoreState) => ({
  company: activeCompanySelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  connectCode: (id: number, companyId: number, facebookPageId: number) =>
    dispatch(promotionsCRUDActions.connect(id, companyId, facebookPageId)),
});

const enhance = compose<InnerProps, OuterProps>(
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(PromoRedemptionSelector);
